import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { JsonLdDirective, JsonLdScriptFactory } from '@spartacus/storefront';

@Directive({
  selector: '[wcCxJsonLd]',
  standalone: true
})
export class CustomJsonLdDirective extends JsonLdDirective {
  @Input() set wcCxJsonLd(schema: string | object) {
    this.generateJsonLdScript(schema);
  }

  constructor(
    protected renderer: Renderer2,
    protected jsonLdScriptFactory: JsonLdScriptFactory,
    protected element: ElementRef
  ) {
    super(renderer, jsonLdScriptFactory, element);
  }

  protected generateJsonLdScript(schema: string | object): void {
    if (schema) {
      const elementChildren = Array.from(this.element.nativeElement.children);
      const script: HTMLScriptElement = this.renderer.createElement('script');

      script.type = 'application/ld+json';
      script.textContent = this.jsonLdScriptFactory.escapeHtml(schema);

      if (elementChildren.length > 0) {
        elementChildren.forEach((child) => this.element.nativeElement.removeChild(child));
      }

      this.renderer.appendChild(this.element.nativeElement, script);
    }
  }
}
